import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AcessoRouterService
{
    constructor(private router: Router) {}
}
